import styled from "styled-components";

export const UploadWrapper = styled.div`
    
`;

export const UploadContent = styled.div`
    background-color: #fbfbfb;
    border: 1px #48A5FD dashed;
    width: 100%;
    padding: 28px;
    border-radius: 4px;
    outline: 0;
    text-align: center;
    h4{
        font-size: 18px;
        line-height: 20px;
        font-weight: 700;
        color: #4A4A4A;
        margin-bottom: 8px;
    }
`;
export const UploadCont = styled.div`
    outline: 0;
`;
export const Description = styled.p`
    font-size: 12px;
    line-height: 14px;
    color: #777777;
    margin-bottom: 32px;
    span{
        font-weight: 700;
    }
`;
export const Drag = styled.p`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 14px;
    color: #9B9B9B;
    margin-bottom: 14px;
    .sprite{
        margin-right: 6px;
    }
`;
export const Or = styled.p`
    font-size: 12px;
    line-height: 14px;
    color: #9B9B9B;
    margin-bottom: 16px;
`;
export const SelectBtn = styled.button`
    width: 100%;
    height: 37px;
    background-color: #fff;
    border: 1px #008CFF solid;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: 0;
    cursor: pointer;
    font-size: 14px;
    text-transform: uppercase;
    color: #008CFF;
    font-family: 'Lato';
    font-weight: 700;
    position: relative;
    ${p => p.disabled && `
        color: rgb(0, 140, 255, 0.2);
    `}
`;
export const Info = styled.p`
    font-size: 12px;
    line-height: 14px;
    color: #4A4A4A;
    margin-top: 10px;
`;
export const UploadedFileItemCont = styled.div`

`;
export const UploadedFileItem = styled.div`
    background-color: #F7F7F7;
    border: 1px #D8D8D8 solid;
    border-radius: 2px;
    padding: 6px 10px;
    display: flex;
    align-items: center;
    margin-top: 16px;
    text-align: left;
    ${p => p.isError && `
        border-color: #FF888C;
    `}
`;
export const ErrorMsg = styled.p`
    font-size: 12px;
    line-height: 14px;
    color: #EB2026;
    margin-top: 3px;
    text-align: left;
`;
export const FilteTypeIcon = styled.span`
    flex-shrink: 0;
    margin-right: 10px;
`;
export const FileName = styled.p`
    font-size: 12px;
    line-height: 14px;
    color: #000000;
`;
export const FileSize = styled.p`
    font-size: 12px;
    line-height: 14px;
    color: #9B9B9B;
    margin-top: 3px;
`;
export const UploadedFileItemDesc = styled.div`
    flex: 1;
`;

